export const urlFriendlyString = (value: string | undefined) => {
  return typeof value === "undefined"
    ? ""
    : value
        .replace(/[^a-z0-9_]+/gi, "-")
        .replace(/^-|-$/g, "")
        .toLowerCase();
};
